import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../_shared/shared.module';

import { AdvancedSearchRoutingModule } from './advanced.search.routing';
import { DatepickerModule } from '../_globals';
import { AdvancedSearchComponent } from './advanced.search.component';
import { LexileNumberDirective } from './lexile.number.directive';
import {
  ResourceTypeService,
  PubDateOptionService
} from '../_services';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    SharedModule,
    AdvancedSearchRoutingModule,
    DatepickerModule
  ],
  declarations: [
    LexileNumberDirective,
    AdvancedSearchComponent
  ],
  providers: [
    ResourceTypeService,
    PubDateOptionService,
  ]
})
export class AdvancedSearchModule {
}
